// Full-document render of the tempurpedic RetailLocatorPage2: PageSkeleton
// (the React document shell) wrapping the retail-locator SPA (normal site
// chrome). The RetailLocatorPageSSR component renders here in-tree, fed by
// the page's two visibility flags.
import React from "react";

import { templates } from "@reactivated";

import { RetailLocatorPageSSR } from "../apps/retail-locator/RetailLocatorPageSSR";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.RetailLocatorPage2Template;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <RetailLocatorPageSSR
                hide_elite={props.page.hide_elite}
                hide_tp_stores={props.page.hide_tp_stores}
            />
        </PageSkeleton>
    );
};
